// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c89c1e2","952":"f8bbfe80"}[chunkId] + ".chunk.js";
};